import debounce from 'lodash/debounce';
import get from 'lodash/get';
// store import to be addressed in APP-129700
// eslint-disable-next-line no-restricted-imports
import store from '@/vuex/store';

const titleContext = { entityName: null, action: null, entityType: null };
let _router = null;

export function initTitleContext (router) {
    _router = router;
}

export const scheduleApplyTitle = debounce(() => {
    if (_router?.currentRoute?.value) {
        applyRouteTitle(_router.currentRoute.value);
    }
}, 10);

export function setTitleContext (context = {}) {
    if ('entityName' in context) titleContext.entityName = context.entityName;
    if ('action' in context) titleContext.action = context.action;
    if ('entityType' in context) titleContext.entityType = context.entityType;
    scheduleApplyTitle();
}

export function clearTitleContext () {
    titleContext.entityName = null;
    titleContext.action = null;
    titleContext.entityType = null;
}

export function applyRouteTitle (to) {
    const { entityName, action, entityType: contextEntityType } = titleContext;
    const entityType = contextEntityType ?? to.meta?.title ?? '';
    const base = entityName && entityType
        ? `${entityName} - ${entityType}`
        : (entityName ?? entityType ?? '');
    const titlePart = action ? `${action} - ${base}` : base;

    if (to?.meta?.prefixDomainTitle === false && to?.meta?.title && !titleContext.entityName) {
        document.title = to.meta.title;
    } else {
        let domain = '';
        if (!store.state.auth.authenticated) {
            domain = get(store.state.auth, 'unauthenticatedTrainingAttributes.productName') || 'pendo.io';
        } else {

            // This is a bit of a hack, but it's the only way to get the AEU product line status
            // without waiting for the product lines to load.
            const adoptEndUserProductLine = store.state.subscription.active?.productLines?.find((pl) => pl.type === 'adoptEndUser');

            const isAEU = adoptEndUserProductLine?.purchased;
            const hostnamePath = isAEU ? 'hosts.oem' : 'hosts.main';
            const whiteLabelHostname = get(store.state.subscription.active, 'trainingAttributes.hostname');
            domain = whiteLabelHostname || get(store.state.config, hostnamePath) || 'pendo.io';
        }

        document.title = domain + (titlePart ? `: ${titlePart}` : '');
    }
}
